export default __webpack_public_path__ + "static/media/atom.d27f0d02.svg";